<template>
  <div class="vip-page">
    <div class="user-panel">
      <img class="avatar" :src="userInfo.avatar | getAvatarUrl" />
      <div class="user-content">
        <div class="name">{{userInfo.nick_name}}</div>
        <div v-if="userInfo.is_vip">
          您已是超级会员，将在
          <span style="color:#F56C6C">{{userInfo.vip_expire_in | transLocalTime}}</span>
           到期
        </div>
        <div v-else-if="userInfo.vip_expire_in">超级会员已过期，续费即享多项权益</div>
        <div v-else>未开通超级会员，开通即享多项权益</div>
      </div>
    </div>
    <div class="panel shadow">
      <div class="price-list">
        <div
          class="item"
          :class="{'active': index === selectedPriceIndex}"
          v-for="(item, index) in vipPriceList"
          :key="index"
          @click="handlePriceClick(index, item.type)">
          <div class="money"><span>￥</span>{{item.price}}</div>
          <div class="name">{{item.name}}</div>
          <div class="origin-price">原价￥{{item.price * 1.2 | mathFixed}}</div>
        </div>
      </div>
      <div class="task-limit">可领取任务数量为 <strong>{{currentPriceTaskLimit}}</strong></div>
      <div class="pay-button">
        <van-button
          slot="button"
          block
          type="warning"
          @click="dispatchPay">立即{{userInfo.vip_expire_in ? '续费' : '开通'}}</van-button>
      </div>
    </div>
    <div class="panel shadow">
      <div class="title">会员权益</div>
      <div
        class="content"
        v-if="systemInfo.vip_description"
        v-html="systemInfo.vip_description.replace(/\n/g, '<br>')">
      </div>
    </div>
    <van-action-sheet v-model="showPayType" title="请选择支付方式">
      <van-cell-group>
        <van-cell clickable v-if="isAPP && systemInfo.use_apppay" @click="dispatchPay">
          <template #title>
            <van-icon size="36px" style="vertical-align: bottom;" color="#04BE02" name="wechat" />
            <span class="pay-label">微信</span>
          </template>
          <template #right-icon>
            <van-checkbox />
          </template>
        </van-cell>
        <van-cell clickable v-if="isWechat && systemInfo.use_publicpay" @click="dispatchPay">
          <template #title>
            <van-icon size="36px" style="vertical-align: bottom;" color="#04BE02" name="wechat" />
            <span class="pay-label">微信</span>
          </template>
          <template #right-icon>
            <van-checkbox />
          </template>
        </van-cell>
        <van-cell clickable v-if="isAPP && systemInfo.use_app_alipay" @click="dispatchPay">
          <template #title>
            <van-icon size="36px" style="vertical-align: bottom;" color="#108ee9" name="alipay" />
            <span class="pay-label">支付宝</span>
          </template>
          <template #right-icon>
            <van-checkbox />
          </template>
        </van-cell>
      </van-cell-group>
    </van-action-sheet>
  </div>
</template>

<script>
import {
  Button,
  Grid,
  GridItem,
  Cell,
  CellGroup,
  Toast,
  RadioGroup,
  Radio,
  Notify,
  ActionSheet,
  Icon,
  Checkbox,
} from 'vant';
import UsersProxy from '@/proxies/users';
import CommonProxy from '@/proxies/common';

export default {
  data() {
    return {
      channels: [],
      vipPriceList: [],
      vipType: null,
      openId: '',
      selectedPriceIndex: 0,
      showPayType: false,
      payType: 'wxpay',
    };
  },
  components: {
    [Button.name]: Button,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Toast.name]: Toast,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Notify.name]: Notify,
    [ActionSheet.name]: ActionSheet,
    [Icon.name]: Icon,
    [Checkbox.name]: Checkbox,
  },
  computed: {
    currentPriceTaskLimit() {
      const result = this.vipPriceList.length
        ? this.vipPriceList[this.selectedPriceIndex].task_limit : 0;
      if (result < 0) {
        return '无限制';
      }
      return result;
    },
    systemInfo() {
      return this.$store.state.system.info;
    },
    userInfo() {
      return this.$store.state.account.info;
    },
    isAPP() {
      return navigator.userAgent.indexOf('Html5Plus') > -1;
    },
    isWechat() {
      return this.$tools.isWechat();
    },
    appid() {
      return window.API_CONFIG['wechat_appid'];
    },
  },
  created() {
    this.getVipPrice();
  },
  mounted() {
    // 从缓存读取openid
    const openid = this.$storage.getItem('openid');
    if (openid && openid !== 'undefined' && openid !== 'null') {
      this.openId = openid;
    }
    // 从缓存里读取用户此前输入的金额
    const vipType = this.$storage.getItem('vipType');
    if (vipType && vipType !== 'undefined' && vipType !== 'null') {
      this.vipType = +vipType;
    } else {
      this.vipType = null;
    }
    const { code } = this.$route.query;
    if (code && this.isWechat) {
      // 如果是微信授权回调
      this.publicSession(code);
    }
  },
  methods: {
    onCopy() {
      this.$toast('复制成功');
    },
    onError() {
      this.$toast('复制失败');
    },
    handlePriceClick(index, type) {
      this.selectedPriceIndex = index;
      this.vipType = type;
    },
    // 支付宝支付
    async goAppAlipay() {
      this.payType = 'alipay';
      const money = this.vipPriceList.find(item => item.type === this.vipType).price;
      if (!money) {
        Notify('金额异常');
        return;
      }
      const params = {
        money: money,
        name: 'APP开通或续费会员',
        user_id: this.userInfo.id,
        notify_url: `${window.API_CONFIG['app']}/order/alipayVipNotify`,
      };
      const res = await CommonProxy.appAlipayAddOrder(params);
      if (res.success) {
        this.requestAppPay(res.data);
      }
    },
    // 唤起APP支付
    requestAppPay(data) {
      window.plus.payment.getChannels((channels) => {
        let channel = '';
        for (const i in channels) {
          if (channels[i].id === this.payType) {
            channel = channels[i];
          }
        }
        window.plus.payment.request(channel, data, (result) => {
          // 支付成功
          console.info(result);
          Toast('支付成功');
          this.$store.dispatch('account/find', {
            userId: this.userInfo.id,
          });
          setTimeout(() => {
            this.$router.push({
              name: 'vip.index',
            });
          });
        }, (error) => {
          Notify(`支付失败${error.code}`);
        });
      }, (e) => {
        Notify(`获取支付通道失败：${e.message}`);
      });
    },
    dispatchPay() {
      this.payType = 'wxpay';
      if (this.isAPP && this.systemInfo.use_apppay) {
        // 如果打开了APP微信支付
        if (!this.showPayType) {
          this.showPayType = true;
          return;
        }
        this.gotoPay();
      } else if (this.isAPP && this.systemInfo.use_app_alipay) {
        // 如果打开了APP支付宝支付
        if (!this.showPayType) {
          this.showPayType = true;
          return;
        }
        this.goAppAlipay();
      } else if (this.isWechat && this.systemInfo.use_publicpay) {
        if (!this.showPayType) {
          this.showPayType = true;
          return;
        }
        // 在微信里
        this.publicAddOrder();
      } else {
        // 在普通浏览器
        this.$router.push({
          name: 'vip.guide',
        });
      }
    },
    async getVipPrice() {
      const res = await UsersProxy.getVipPrice();
      if (res.success) {
        const vipPriceList = [];
        res.data.forEach((item) => {
          if (item.is_show) {
            vipPriceList.push(item);
          }
        });
        this.vipPriceList = vipPriceList;
        this.vipType = this.vipPriceList[0].type;
      }
    },
    // 微信下单
    async gotoPay() {
      const money = this.vipPriceList.find(item => item.type === this.vipType).price;
      if (!money) {
        Notify('金额异常');
        return;
      }
      const params = {
        money: money,
        user_id: this.userInfo.id,
        notify_url: `${window.API_CONFIG['app']}/order/joinMemberNotify`,
        remark: 'APP开通或续费会员',
      };
      const res = await CommonProxy.appAddOrder(params);
      if (res.success) {
        this.requestAppPay(res.data);
      }
    },
    // 公众号获取openid
    async publicSession(code) {
      const params = {
        code,
      };
      const res = await CommonProxy.publicSession(params);
      if (res.success) {
        this.openId = res.data.openid;
        this.publicAddOrder();
      }
    },
    // 公众号充值
    async publicAddOrder() {
      const money = this.vipPriceList.find(item => item.type === this.vipType).price;
      if (!money) {
        Notify('金额异常');
        return;
      }
      if (!this.openId) {
        // 如果没有openId，则先去获取
        this.wechatAuth();
        return;
      }
      const params = {
        openId: this.openId,
        money: money,
        user_id: this.userInfo.id,
        notify_url: `${window.API_CONFIG['app']}/order/joinMemberNotify`,
        remark: 'H5开通或续费会员',
      };
      const res = await CommonProxy.publicAddOrder(params);
      if (res.success) {
        this.publicInvokePay(res.data);
      }
    },
    // 微信跳转授权
    wechatAuth() {
      // 先缓存用户输入的金额
      this.$storage.setItem('vipType', this.vipType);
      this.$storage.setItem('wechatAuthFrom', 3);
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appid}&redirect_uri=${window.location.origin}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
    },
    // 公众号网页唤起微信支付
    publicInvokePay(data) {
      window.WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        {
          appId: data.appId,
          timeStamp: data.timeStamp,
          nonceStr: data.nonceStr,
          package: `prepay_id=${data.prepayId}`,
          signType: 'MD5',
          paySign: data.paySign,
        },
        (res) => {
          if (res.err_msg === 'get_brand_wcpay_request:ok') {
            // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            this.$store.dispatch('account/find', {
              userId: this.userInfo.id,
            });
            setTimeout(() => {
              this.$router.push({
                name: 'vip.index',
              });
            });
          }
        },
      );
    },
  },
};
</script>

<style lang="less" scoped>
  .vip-page {
    background-color: #fff;
    .user-panel {
      display: flex;
      align-items: center;
      padding: 10px;
    }
    .user-panel .avatar {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      -ms-border-radius: 50%;
      -o-border-radius: 50%;
      box-shadow: 1px 1px 20px #eee;
    }
    .user-content {
      flex: 1;
      color: #666;
      font-size: 12px;
      margin-left: 10px;
    }
    .user-content .name {
      color: #333;
      font-size: 16px;
    }
    .pay-button {
      padding: 0 10px;
      margin-bottom: 40px;
      .van-button {
        background-color: #f75422;
        border-color: #f75422;
      }
    }
    .price-list {
      padding: 10px;
      box-sizing: border-box;
      white-space: nowrap;
      overflow-x: auto;
      width: 100%;
      .item {
        padding: 20px 10px;
        border-radius: 15px;
        width: 88px;
        display: inline-block;
        box-sizing: border-box;
        -webkit-border-radius: 15px;
        -moz-border-radius: 15px;
        -ms-border-radius: 15px;
        -o-border-radius: 15px;
        background-color: #fff;
        border: 1px solid #fff;
        margin: 10px 5px 10px 0;
        box-shadow: 1px 1px 5px #eee;
        &.active {
          padding-bottom: 30px;
          border-color: #f75422;
          color: #f75422;
          background-color: #fdece6;
        }
        .name {
          font-size: 14px;
          color: #666;
        }
        .origin-price {
          color: #999;
          font-size: 12px;
          text-decoration: line-through;
        }
        .money {
          font-size: 20px;
          font-weight: bold;
          span {
            font-size: 12px;
            vertical-align: super;
          }
        }
      }
    }
    .task-limit {
      margin: 0 10px 10px 10px;
      color: #666;
      strong {
        color: #333;
      }
    }
    .panel {
      color: #333;
      margin: 10px 0;
      &.last-panel {
        margin-bottom: 75px;
      }
      .title {
        margin: 10px;
        font-size: 16px;
        font-weight: bold;
      }
      .content {
        background-color: #fff;
        padding: 10px;
        border-radius: 2px;
        .price {
          font-size: 18px;
          color: #F56C6C;
          font-weight: bold;
        }
        &.qrcode {
          text-align: center;
          img {
            max-width: 50%;
          }
        }
      }
      .copy {
        margin-left: 10px;
      }
    }
    .pay-label {
      display: inline-block;
      vertical-align: super;
      margin-left: 10px;
    }
    .fixed-bottom {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      margin: 0;
    }
  }
</style>
